module.exports = __webpack_public_path__ + "img/dianchi-60.1c1c71cf.png";